export default "__VITE_ASSET__CcBo5pgx__"